module.exports = __webpack_public_path__ + "media/img/logos/swiss-a01eb0c328f9f13baf2593ee158d14c1.svg";